import React from 'react'

import banner from '../images/banner/one_year.png'

import { PiTelevisionBold } from "react-icons/pi";
import { IoIosArrowBack } from "react-icons/io";
import { IoIosArrowForward } from "react-icons/io";
import { RiWhatsappLine } from "react-icons/ri";

const CourseOne = () => {
    return (
        <>

            <div>

                <div className='relative font-[poppins]'>

                    <div className='relative'>
                        <img src={banner} className='w-full object-cover ' alt="" />
                        <div className='absolute top-0 w-full inset-0 backdrop-blur-sm  bg-black/30 md:bg-black/45'></div> 
                    </div>

                    <div className='absolute top-10 md:top-40 left-8 right-8 md:left-20 '>

                        <h3 className='font-bold text-[14px] md:text-[44px] text-white uppercase text-center'>1 Year Course In</h3>
                        <h3 className='font-bold text-[14px] md:text-[44px] text-white uppercase text-center'> Visual Effects & Computer graphics</h3>

                    </div>
 
                </div>
            </div>


            <div>

                <section className='font-[poppins] pt-8 md:pt-20  pb-8 md:pb-20'>
                    <div className=' w-full px-4 md:w-[80%] mx-auto'>

                        <div >
                            <h3 className='font-bold text-[14px] md:text-[24px] text-gray-950 uppercase mb-2 md:mb-4 text-center md:text-start'>Course Objective</h3>
                            <p className='font-normal text-gray-700 text-[12px] md:text-[14px]  text-justify md:text-start '>The objective of this course is to provide students with comprehensive training in the tools, techniques, and practices essential for success in the dynamic field of visual effects. By the end of the course, students will:</p>
                        </div>

                        <div className=' flex flex-col items-center mt-6 md:mt-12  gap-y-5 md:gap-y-8 font-[roboto]'>

                            <div className=''>
                                <p className=' text-[12px] md:text-[14px] text-gray-800'> <span className='font-semibold text-gray-950'>Master Industry-Standard Software:</span>  Develop proficiency in industry-leading software such as Adobe Creative Cloud (Photoshop, After Effects), Blender, Autodesk Maya, and Nuke, gaining hands-on experience in each tool's unique capabilities and workflows.</p>
                            </div>

                            <div>
                                <p className=' text-[12px] md:text-[14px] text-gray-800'> <span className='font-semibold text-gray-950'>Acquire Specialized Skills:</span>  Gain specialized skills in key areas of VFX production, including roto-scoping, matte painting, matchmove, motion graphics, 3D modeling, texturing, lighting, rigging, animation, rendering, and compositing.</p>
                            </div>

                            <div>
                                <p className=' text-[12px] md:text-[14px] text-gray-800'> <span className='font-semibold text-gray-950'>Understand VFX Pipeline:</span>   Gain a deep understanding of the VFX production pipeline, from conceptualization and pre-production to on-set supervision, post-production, and final delivery, ensuring familiarity with industry-standard processes and practices.</p>
                            </div>

                            <div>
                                <p className=' text-[12px] md:text-[14px] text-gray-800'> <span className='font-semibold text-gray-950'>Explore Advanced Techniques:</span>   Explore advanced VFX techniques such as lighting optimization, rendering optimization, and AI integration, enabling students to tackle complex challenges and push the boundaries of creativity in their projects. </p>
                            </div>

                            <div>
                                <p className=' text-[12px] md:text-[14px] text-gray-800'> <span className='font-semibold text-gray-950'>Develop Collaborative and Problem-Solving Skills:</span>    Collaborate with peers on integrative projects, developing problem-solving skills, teamwork abilities, and project management capabilities essential for success in a collaborative industry environment. </p>
                            </div>

                            <div>
                                <p className='text-[12px] md:text-[14px] text-gray-800'> <span className='font-semibold text-gray-950'>Build a Professional Portfolio:</span>     Create a professional portfolio showcasing their skills and projects developed throughout the course, enabling students to demonstrate their expertise to potential employers and clients in the VFX industry</p>
                            </div>

                            <div>
                                <p className='text-[12px] md:text-[14px] text-gray-800'> <span className='font-semibold text-gray-950'>Gain Real-World Experience:</span>     Gain real-world experience through on-set VFX supervision, studio visits, and a 3-month internship at a renowned VFX studio, providing valuable insights into industry practices, networking opportunities, and practical experience in a professional setting.</p>
                            </div>

                            <div>
                                <p className='text-[12px] md:text-[14px] text-gray-800'> <span className='font-semibold text-gray-950'>Cultivate Lifelong Learning:</span>   Instill a passion for lifelong learning and professional development, equipping students with the skills and mindset to adapt to evolving technologies, industry trends, and creative challenges throughout their careers in the dynamic field of visual effects.</p>
                            </div>


                        </div>

                        <div className='font-[poppins]  mt-8 md:mt-20'>

                            <div className='flex justify-center items-center'>
                                <h5 className='text-[16px] md:text-[20px] uppercase font-bold tracking-[1px] md:tracking-[2px]'>Course Outline</h5>
                            </div>

                            <div className=' mt-4 md:mt-8'>

                                <div className='grid grid-cols-1 md:grid-cols-2  gap-x-8 gap-y-6 md:gap-y-10  md:border border-gray-200 rounded-md  md:px-8  md:py-8' >

                                    <div className=' md:border-r border-gray-300'>
                                        <div>
                                            <h3 className='font-semibold  text-[14px] md:text-[18px] text-gray-950 '>Month 1-2: Introduction to VFX & Adobe Tools</h3>

                                            <div className=' mt-4 md:mt-6 flex flex-col gap-y-3'>

                                                <div>
                                                    <p className='font-semibold text-[12px] md:text-[14px] mb-2 md:mb-3'>History and Introduction of VFX</p>

                                                    <ul className='list-disc flex flex-col gap-y-1 text-[12px] md:text-[14px] font-[roboto] ml-4 md:ml-6 text-gray-700'>

                                                        <li>Introduction to the evolution and importance of VFX, covering milestones and pioneers in the field.</li>
                                                        <li>Exploration of VFX technologies from practical effects to CGI, with a focus oncontemporary applications.</li>
                                                        <li>Discussion on ethics, emerging trends, and the role of VFX in shaping the future of media.</li>

                                                    </ul>
                                                </div>

                                                <div>
                                                    <p className='font-semibold text-[12px] md:text-[14px] mb-2 md:mb-3'>Introduction to Adobe Creative Cloud</p>

                                                    <ul className='list-disc flex flex-col gap-y-1 text-[12px] md:text-[14px] font-[roboto] ml-4 md:ml-6 text-gray-700'>
                                                        <li>Overview of Adobe Photoshop, Illustrator, and After Effects</li>
                                                        <li>Basic Tools and Interface Navigation</li>
                                                    </ul>
                                                </div>

                                                <div>
                                                    <p className='font-semibold text-[12px] md:text-[14px] mb-2 md:mb-3'>VFX Techniques in Adobe After Effects</p>

                                                    <ul className='list-disc flex flex-col gap-y-1 text-[12px] md:text-[14px] font-[roboto] ml-4 md:ml-6 text-gray-700'>
                                                        <li>  Rotoscoping and Masking</li>
                                                        <li>Chroma Keying (Green Screen)</li>
                                                        <li>Tracking and Stabilization</li>

                                                    </ul>
                                                </div>

                                            </div>
                                        </div>
                                    </div>


                                    <div className=' md:pl-10'>
                                        <div>
                                            <h3 className='font-semibold text-[14px] md:text-[18px] text-gray-950'>Month 3: Rotoscopy and Matte Painting</h3>

                                            <div className=' mt-4 md:mt-6 flex flex-col gap-y-3'>

                                                <div>
                                                    <p className='font-semibold text-[12px] md:text-[14px]  mb-2 md:mb-3'>Rotoscopy Fundamentals</p>

                                                    <ul className='list-disc flex flex-col gap-y-1  text-[12px] md:text-[14px] font-[roboto] ml-4 md:ml-6 text-gray-700'>
                                                        <li>Understanding Rotoscopy Techniques</li>
                                                        <li>Rotoscoping Softwares: Silhouette, Mocha Pro</li>

                                                    </ul>
                                                </div>

                                                <div>
                                                    <p className='font-semibold text-[12px] md:text-[14px] mb-2 md:mb-3'>Matte Painting Techniques</p>

                                                    <ul className='list-disc flex flex-col gap-y-1 text-[12px] md:text-[14px] font-[roboto] ml-4 md:ml-6 text-gray-700'>

                                                        <li> Digital Painting Fundamentals</li>
                                                        <li>Matte Painting Workflow</li>
                                                        <li>Software: Adobe Photoshop</li>
                                                    </ul>

                                                </div>
                                            </div>
                                        </div>
                                    </div>




                                    <div className=' md:border-r border-gray-300'>
                                        <div>
                                            <h3 className='font-semibold text-[14px] md:text-[18px] text-gray-950 '>Month 4: Matchmove and Motion Graphics</h3>

                                            <div className=' mt-4 md:mt-6 flex flex-col gap-y-3'>

                                                <div>
                                                    <p className='font-semibold text-[12px] md:text-[14px] mb-2 md:mb-3'>Introduction to Matchmove</p>

                                                    <ul className='list-disc flex flex-col gap-y-1 text-[12px] md:text-[14px] font-[roboto] ml-4 md:ml-6 text-gray-700'>

                                                        <li>Matchmove Fundamentals</li>
                                                        <li>Tracking Techniques</li>
                                                        <li>Software: PFTrack, Boujou</li>

                                                    </ul>
                                                </div>

                                                <div>
                                                    <p className='font-semibold text-[12px] md:text-[14px] mb-2 md:mb-3'>Motion Graphics</p>

                                                    <ul className='list-disc flex flex-col gap-y-1 text-[12px] md:text-[14px] font-[roboto] ml-4 md:ml-6 text-gray-700'>


                                                        <li>Motion Graphics Principles</li>
                                                        <li>Animation Techniques in After Effects</li>
                                                        <li>Software: Adobe After Effects</li>

                                                    </ul>

                                                </div>


                                            </div>
                                        </div>
                                    </div>


                                    <div className=' md:pl-10'>
                                        <div>
                                            <h3 className='font-semibold  text-[14px] md:text-[18px] text-gray-950 '>Month 5-6: Fundamentals of Blender & Unreal Engine</h3>

                                            <div className='mt-4 md:mt-6 flex flex-col gap-y-3'>

                                                <div>
                                                    <p className='font-semibold  text-[12px] md:text-[14px] mb-2 md:mb-3'>Introduction to Blender</p>

                                                    <ul className='list-disc flex flex-col gap-y-1 text-[12px] md:text-[14px] font-[roboto] ml-4 md:ml-6 text-gray-700'>

                                                        <li>Blender Interface and Navigation</li>
                                                        <li>Modeling Tools and Techniques</li>

                                                    </ul>
                                                </div>

                                                <div>
                                                    <p className='font-semibold text-[12px] md:text-[14px] mb-2 md:mb-3'>Texturing and Shading in Blender</p>

                                                    <ul className='list-disc flex flex-col gap-y-1 text-[12px] md:text-[14px] font-[roboto] ml-4 md:ml-6 text-gray-700'>

                                                        <li>UV Unwrapping and Texture Painting</li>
                                                        <li>Shading and Material Creation</li>
                                                    </ul>
                                                </div>

                                                <div>
                                                    <p className='font-semibold  text-[12px] md:text-[14px] mb-2 md:mb-3'> Lighting, Rigging, and Animation in Blender</p>

                                                    <ul className='list-disc flex flex-col gap-y-1  text-[12px] md:text-[14px] font-[roboto] ml-4 md:ml-6 text-gray-700'>

                                                        <li>Basics of Lighting and Rendering</li>
                                                        <li>Rigging Characters and Objects</li>
                                                        <li>Animation Principles and Techniques</li>
                                                    </ul>
                                                </div>

                                                <div>
                                                    <p className='font-semibold  text-[12px] md:text-[14px] mb-2 md:mb-3'>Introduction to Unreal Engine</p>

                                                    <ul className='list-disc flex flex-col gap-y-1  text-[12px] md:text-[14px] font-[roboto] ml-4 md:ml-6 text-gray-700'>

                                                        <li>Familiarization with the interface, navigation, and basic tools.</li>
                                                        <li>Techniques for building environments, setting up lighting, and applying materials.</li>
                                                        <li>Basics of animating objects and cameras, and creating cinematic sequences.</li>
                                                        <li>Understanding the fundamentals of real-time rendering for film production.</li>

                                                    </ul>
                                                </div>

                                            </div>
                                        </div>
                                    </div>


                                    <div className=' md:border-r border-gray-300'>
                                        <div>
                                            <h3 className='font-semibold  text-[14px] md:text-[18px] text-gray-950  '>Month 7-8: 3D Modeling and Animation with Autodesk Maya</h3>

                                            <div className=' mt-4 md:mt-6 flex flex-col gap-y-3'>

                                                <div>
                                                    <p className='font-semibold  text-[12px] md:text-[14px] mb-2 md:mb-3'>Introduction to Autodesk Maya</p>

                                                    <ul className='list-disc flex flex-col gap-y-1 text-[12px] md:text-[14px] font-[roboto] ml-4 md:ml-6 text-gray-700'>

                                                        <li>Maya Interface and Navigation</li>
                                                        <li>Polygonal Modeling Techniques</li>

                                                    </ul>
                                                </div>

                                                <div>
                                                    <p className='font-semibold  text-[12px] md:text-[14px] mb-2 md:mb-3'>Advanced Modeling and Texturing in Maya</p>

                                                    <ul className='list-disc flex flex-col gap-y-1 text-[12px] md:text-[14px] font-[roboto] ml-4 md:ml-6 text-gray-700'>

                                                        <li>NURBS Modeling and Organic Modeling</li>
                                                        <li>Texture Mapping and UV Layouts</li>

                                                    </ul>
                                                </div>

                                                <div>
                                                    <p className='font-semibold  text-[12px] md:text-[14px] mb-2 md:mb-3'>Rigging and Animation in Maya</p>

                                                    <ul className='list-disc flex flex-col gap-y-1 text-[12px] md:text-[14px] font-[roboto] ml-4 md:ml-6 text-gray-700'>

                                                        <li>Character Rigging Techniques</li>
                                                        <li>Keyframe Animation and Animation Layers</li>

                                                    </ul>
                                                </div>

                                            </div>
                                        </div>
                                    </div>


                                    <div className=' md:pl-10'>
                                        <div>
                                            <h3 className='font-semibold  text-[14px] md:text-[18px] text-gray-950 '>Month 9-10: Lighting, Rendering, and Optimization</h3>

                                            <div className=' mt-4 md:mt-6 flex flex-col gap-y-3'>

                                                <div>
                                                    <p className='font-semibold  text-[12px] md:text-[14px] mb-2 md:mb-3'>Lighting and Rendering Techniques</p>

                                                    <ul className='list-disc flex flex-col gap-y-1 text-[12px] md:text-[14px] font-[roboto]  ml-4 md:ml-6 text-gray-700'>

                                                        <li>Types of Lights and Lighting Setups</li>
                                                        <li>Introduction to Render Engines (Arnold, V-Ray)</li>


                                                    </ul>
                                                </div>

                                                <div>
                                                    <p className='font-semibold  text-[12px] md:text-[14px] mb-2 md:mb-3'> Rendering Optimization</p>

                                                    <ul className='list-disc flex flex-col gap-y-1 text-[12px] md:text-[14px] font-[roboto] ml-4 md:ml-6 text-gray-700'>

                                                        <li>Render Settings Optimization</li>
                                                        <li>Render Passes and AOVs</li>

                                                    </ul>
                                                </div>


                                            </div>
                                        </div>
                                    </div>


                                    <div className=' md:border-r border-gray-300'>
                                        <div>
                                            <h3 className='font-semibold  text-[14px] md:text-[18px] text-gray-950 '>  Month 11:Compositing with Nuke</h3>

                                            <div className='mt-4  md:mt-6 flex flex-col gap-y-3'>

                                                <div>
                                                    <p className='font-semibold  text-[12px] md:text-[14px] mb-2 md:mb-3'>Introduction to Nuke</p>

                                                    <ul className='list-disc flex flex-col gap-y-1  text-[12px] md:text-[14px] font-[roboto] ml-4 md:ml-6 text-gray-700'>

                                                        <li>Nuke Interface and Node-based Workflow</li>
                                                        <li>Basic Compositing Techniques</li>

                                                    </ul>
                                                </div>


                                                <div>
                                                    <p className='font-semibold  text-[12px] md:text-[14px] mb-2 md:mb-3'>Advanced Compositing Techniques in Nuke</p>

                                                    <ul className='list-disc flex flex-col gap-y-1  text-[12px] md:text-[14px] font-[roboto] ml-4 md:ml-6 text-gray-700'>

                                                        <li>Keying and Rotoscoping</li>
                                                        <li>3D Compositing and Tracking</li>

                                                    </ul>
                                                </div>

                                            </div>
                                        </div>
                                    </div>


                                    <div className='md:pl-10'>
                                        <div>
                                            <h3 className='font-semibold  text-[14px] md:text-[18px] text-gray-950 '>  Month 12: AI Integration and Ethical Use</h3>

                                            <div className='mt-6 flex flex-col gap-y-3'>

                                                <div>
                                                    <p className='font-semibold  text-[12px] md:text-[14px] mb-2 md:mb-3'> AI Tools in VFX</p>

                                                    <ul className='list-disc flex flex-col gap-y-1 text-[12px] md:text-[14px] font-[roboto] ml-4 md:ml-6 text-gray-700'>

                                                        <li>Overview of AI Integration in VFX</li>
                                                        <li>Use Cases and Applications</li>

                                                    </ul>
                                                </div>


                                                <div>
                                                    <p className='font-semibold  text-[12px] md:text-[14px] mb-2 md:mb-3'>   Ethical Use of AI in VFX</p>

                                                    <ul className='list-disc flex flex-col gap-y-1 text-[12px] md:text-[14px] font-[roboto] ml-4 md:ml-6 text-gray-700'  >

                                                        <li>Understanding Bias and Fairness</li>
                                                        <li>Ethical Considerations in AI-Generated Content</li>

                                                    </ul>
                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                </div>


                            </div>

                        </div>

                    </div>


                    <div className=' w-[90%] md:w-[80%] mx-auto mt-12  rounded-lg'>
                        <div className="flex justify-center items-center w-full h-full bg-white border border-dashed border-gray-400 rounded-lg ">
                            <div className='px-4 py-4 md:py-8  flex flex-col gap-y-4 md:gap-y-10 justify-center items-center my-auto h-full'>

                                <div>
                                    <h3 className='text-[14px] md:text-[18px]  font-semibold text-center uppercase'>Join the Academy of Aspiring Filmmakers!</h3>
                                </div>
                                <div className='mt-4 flex justify-center items-center'>
                                    <a href="https://api.whatsapp.com/send?phone=9884683888" target="_blank" rel="noopener noreferrer" className="">

                                        <button className='bg-gray-900 text-white shadow-md drop-shadow-md h-9 pl-3 rounded-md flex items-center gap-x-3  font-[poppins] text-[12px] md:text-[14px] hover:scale-105 duration-500'> Download syllabus <div className='px-3 bg-green-600  rounded-r-md'><RiWhatsappLine className='text-white h-9   text-[22px] font-bold' /> </div>  </button>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            </div>



        </>
    )
}

export default CourseOne